// Who uses Clara Simulations (Filip 2026-11-05: "visible samo za roles: admin, developer, tl, i za ove specific agente …
// neka bude hardcoded za sad"). The API checks the same list (clarab/config/simulationsAccess.js) — keep the two in step.
export const SIMULATION_ROLES = ['admin', 'developer', 'tl'];
export const SIMULATION_EMAILS = [
  'aleksapuseljic@mebit.io',
  'aleksamarkovic@mebit.io',
  'unastanojevic@mebit.io',
  'marijastankov@mebit.io',
  'slavkoknezevic@mebit.io',
  'jovankezic@mebit.io',
  'dimitrijenajdanovic@mebit.io',
];

// x@mebit.io and x@mbcare.io are one person
const person = (email) => String(email || '').trim().toLowerCase().replace(/@(mebit|mbcare)\.io$/, '');
const ALLOWED = new Set(SIMULATION_EMAILS.map(person));

export const canUseSimulations = (user) => !!user && (SIMULATION_ROLES.includes(user.role) || ALLOWED.has(person(user.email)));
